<div class="dgoods-title-with-content-container">
    <div class="title">
        {{ title | injectedText | async }}
    </div>
    <ng-content></ng-content>
</div>
